export const FETCH_VACUUM_STATUS = 'FETCH_VACUUM_STATUS';
export const FETCH_VACUUM_STATUS_SUCCESS = 'FETCH_VACUUM_STATUS_SUCCESS';
export const FETCH_VACUUM_STATUS_FAILURE = 'FETCH_VACUUM_STATUS_FAILURE';

export const FETCH_RDS_EVENTS = 'FETCH_RDS_EVENTS';
export const FETCH_RDS_EVENTS_SUCCESS = 'FETCH_RDS_EVENTS_SUCCESS';
export const FETCH_RDS_EVENTS_FAILURE = 'FETCH_RDS_EVENTS_FAILURE';